import { DateRange } from '../../../../shared/models/date-range.model';
export enum ContractFilterKeys {
  dateRange = 'dateRange',
  locations = 'locations',
  search = 'search',
  status = 'status',
}

export interface ContractFilterValues {
  locations: number[];
  range: DateRange;
  search: string;
  status: ContractStatusOptions[];
}

export enum ContractStatusOptions {
  active = 'active',
  inactive = 'inactive',
  ended = 'ended',
  unknown = 'unknown',
}
